import React, {lazy} from "react";
// import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import {BrowserRouter as Router, Link, Navigate, Route, Routes} from 'react-router-dom';
import {HelmetMeta} from "./HelmetMeta";
import {ThemeProvider} from "../components/theme/ThemeProvider";
import {CssBaseline} from "@material-ui/core";
import {logCredits} from "../utils/logCredits";
import {Home} from "../pages/Home";
// const Resume = lazy(() => import("../pages/Resume"));
import PageNotFound from "../pages/PageNotFound";

export const App = () => {
    logCredits();

    // const scr = (e) => {
    //
    //     if (e.clientY > window.innerHeight - window.innerHeight / 100 * 30) {
    //         console.log(e.clientY > window.innerHeight - window.innerHeight / 100 * 30 )
    //
    //         window.scrollBy(0, 1000);
    //         // window.scrollTo({behavior: 'smooth'})
    //     } else if (e.clientY < window.innerHeight / 100 * 30) {
    //         console.log(e.clientY < window.innerHeight / 100 * 30)
    //         window.scrollBy(0, -1000);
    //     }
    // }

    return (
        <ThemeProvider>
            <CssBaseline/>
            <Router>
                <HelmetMeta/>
                <Routes>
                    <Route exect path="/" element={<Home/>}/>
                    {/* <Route path="/resume" component={Resume} /> */}
                    <Route exect path="*" element={<PageNotFound/>}/>
                </Routes>
            </Router>
        </ThemeProvider>
    );
};
